var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderCircledArrowButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "nfexugae3a",
    width: "128.3%",
    height: "128.3%",
    x: "-14.2%",
    y: "-10.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.196268575 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hfq5lksd2c"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.211765 0 0 0 0 0.192157 0 0 0 0 0.501961 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "ynm9zo8bqb",
    cx: 30,
    cy: 30,
    r: 30
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.97,
    transform: "translate(-270 -348) translate(275 351)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#nfexugae3a)",
    xlinkHref: "#ynm9zo8bqb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#ynm9zo8bqb"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#hfq5lksd2c)",
    transform: "translate(-270 -348) translate(275 351)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2D79",
    strokeWidth: 1.5,
    d: "M0 0L10 10 0 20",
    transform: "matrix(-1 0 0 1 35 20)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderCircledArrowButton);
export default __webpack_public_path__ + "static/media/slider_circled_arrow_button.88c910a827d973dd9a10dbebb73016fb.svg";
export { ForwardRef as ReactComponent };